<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('teacherSubjectCode.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('teacherSubjectCode.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="showForm()">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'teacher.full_name_en'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.academic_year.ac_year }}</td>
          <td>{{ record.subject.subject_name_foreign }}</td>
          <td>{{ record.subject.subject_name_native }}</td>
          <td class="text-center">{{ record.subject_code }}</td>
          <td class="text-center">{{ record.total_hours }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="mr-2 text-primary"
              @click.prevent="showEditForm(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('delete')"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './create'
import EditFormComponent from './edit'
export default {
  name: 'teacher-subject-code',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('teacherSubjectCode', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('teacherSubjectCode.academicYear'),
          sortKey: 'academic_year.ac_year'
        },
        {
          name: this.$t('teacherSubjectCode.subjectNameEn'),
          sortKey: 'subject.subject_name_foreign'
        },
        {
          name: this.$t('teacherSubjectCode.subjectNameKh'),
          sortKey: 'subject.subject_name_native'
        },
        {
          name: this.$t('teacherSubjectCode.subjectCode'),
          sortKey: 'subject_code',
          style: 'text-align:center'
        },
        {
          name: this.$t('teacherSubjectCode.totalHour'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    search: {
      get() {
        return this.$store.state.teacherSubjectCode.search
      },
      set(newValue) {
        this.$store.commit('teacherSubjectCode/SET_SEARCH', newValue)
        this.$store.commit('teacherSubjectCode/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showEditForm(editData) {
      this.$modal.show(
        EditFormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('teacherSubjectCode/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('teacherSubjectCode/destroy', record.sstc_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(errors => {
            this.$toasted.error(errors.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('teacherSubjectCode/RESET_STATE')
    next()
  }
}
</script>
